import { render } from "./form11.vue?vue&type=template&id=118576be&scoped=true"
import script from "./form11.vue?vue&type=script&lang=js"
export * from "./form11.vue?vue&type=script&lang=js"

import "./form11.vue?vue&type=style&index=0&id=118576be&scoped=true&lang=less"

import exportComponent from "/Users/a/k618/work/sxdsjtj/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-118576be"]])

export default __exports__